import { reactive, computed } from 'vue';

const steps = [
  { range: [0, 1], label: 'Hobby site / Average Traffic' },
  { range: [1, 2], label: 'Small E-commerce' },
  { range: [2, 6], label: 'Medium E-commerce' },
  { range: [6], label: 'Large E-commerce' }
];

const cleanNumber = val => Math.ceil(Math.abs(val));

const calc = reactive({

  seats: 1,
  zones: 1,
  queries: 0,
  infoPanelOpen: false,
  plans: [],

  roundedZones: computed(() => cleanNumber(calc.zones)),
  purchasedSeats: computed(() => calc.seats - 1),

  trafficDescriptor: computed(() => steps.find(step => {
    const [min, max] = step.range;
    if (!max) return true;
    return calc.queryBlocks >= min && calc.queryBlocks <= max;
  }).label),

  queryBlocks: computed(() => {
    const blocks = Math.abs(calc.queries / 1000000);
    return blocks > 1 ? blocks : 1;
  }),

  // make sure we are dealing with numbers...
  commitPlans (plans) {
    calc.plans = plans.map(plan => ({
      ...plan,
      price: Number(plan.price),
      price_per_query_block: Number(plan.price_per_query_block),
      price_per_seat: Number(plan.price_per_seat),
      price_per_zone: Number(plan.price_per_zone)
    })).concat({ name: 'Custom', display_name: 'Enterprise', custom: true, price: 0 });
  },

  findPlanById: (planId) => calc.plans.find(({ id }) => id === planId),

  totalsForPlan (planId) {
    const plan = calc.findPlanById(planId);
    const zones = calc.roundedZones * plan.price_per_zone;
    const seats = plan.price_per_seat ? calc.purchasedSeats * plan.price_per_seat : 0;
    const queries = calc.queryBlocks * plan.price_per_query_block * calc.roundedZones;

    return {
      zones,
      seats,
      queries,
      subscription: plan.price,
      sum: seats + queries + zones + plan.price
    };
  }

});

export default calc;
